module.exports = function drawPizza(ctx) {
  ctx.save();
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(18, 0);
  ctx.lineTo(18, 19);
  ctx.lineTo(0, 19);
  ctx.closePath();
  ctx.clip();
  ctx.strokeStyle = 'rgba(0,0,0,0)';
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.save();
  ctx.fillStyle = '#ffdf40';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(2.053, 5.795);
  ctx.translate(9.018345825070071, 16.62199559144544);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.874, -2.142469283130931, -1.5699687536904956, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.018345825070071, -16.62199559144544);
  ctx.bezierCurveTo(
    11.565,
    3.7479999999999998,
    13.933,
    4.481999999999999,
    15.940999999999999,
    5.754
  );
  ctx.lineTo(8.986, 18.092);
  ctx.lineTo(2.053, 5.795);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#ffdf40';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(2.053, 5.795);
  ctx.translate(9.018345825070071, 16.62199559144544);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.874, -2.142469283130931, -1.5699687536904956, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.018345825070071, -16.62199559144544);
  ctx.bezierCurveTo(
    11.565,
    3.7479999999999998,
    13.933,
    4.481999999999999,
    15.940999999999999,
    5.754
  );
  ctx.lineTo(8.986, 18.092);
  ctx.lineTo(2.053, 5.795);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#ffa31a';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(15.941, 5.754);
  ctx.lineTo(17.4, 3.168);
  ctx.translate(9.029219880119381, 13.010879720112984);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.921, -0.8660467874524094, -2.2814982295150372, 1);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.029219880119381, -13.010879720112984);
  ctx.lineTo(2.052999999999998, 5.795);
  ctx.translate(9.018347169935046, 16.6219947262515);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.874, -2.1424694073449864, -1.5698911821890151, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.018347169935046, -16.6219947262515);
  ctx.bezierCurveTo(11.565999999999999, 3.748, 13.933, 4.482, 15.942, 5.754);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#dc1c4b';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(1.858, 5.36);
  ctx.translate(9.018425420187592, 16.064996441005075);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.879, -2.1603340231136614, -1.5700529010091713, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.018425420187592, -16.064996441005075);
  ctx.bezierCurveTo(
    11.647,
    3.1860000000000004,
    14.086,
    3.9680000000000004,
    16.136,
    5.317
  );
  ctx.lineTo(15.902999999999999, 5.73);
  ctx.translate(9.040607269917343, 16.618994766189793);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 12.871, -1.0084566785325626, -1.5716981426204462, 1);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.040607269917343, -16.618994766189793);
  ctx.bezierCurveTo(
    6.481999999999999,
    3.748,
    4.1049999999999995,
    4.488,
    2.09,
    5.771000000000001
  );
  ctx.lineTo(1.8579999999999999, 5.360000000000001);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#febe40';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(3.133, 7.711);
  ctx.lineTo(2.675, 6.898000000000001);
  ctx.translate(3.182943487726767, 7.1289922363976075);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 0.558, -2.7147876016617154, -1.5760714188701996, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-3.182943487726767, -7.1289922363976075);
  ctx.bezierCurveTo(
    3.4879999999999995,
    6.571000000000001,
    3.7379999999999995,
    6.827000000000001,
    3.7509999999999994,
    NaN
  );
  ctx.bezierCurveTo(
    4.315999999999999,
    NaN,
    3.7509999999999994,
    NaN,
    4.7509999999999994,
    NaN
  );
  ctx.bezierCurveTo(5.321, NaN, NaN, NaN, 19.191, NaN);
  ctx.bezierCurveTo(18.773, NaN, NaN, NaN, 19.756, NaN);
  ctx.bezierCurveTo(19.756, NaN, 19.088, NaN, NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.translate(NaN, NaN);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 0.565, NaN, NaN, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.bezierCurveTo(NaN, NaN, NaN, NaN, NaN, NaN);
  ctx.moveTo(8.184, 11.152);
  ctx.bezierCurveTo(
    8.184,
    11.466999999999999,
    7.933999999999999,
    11.722,
    7.6259999999999994,
    11.722
  );
  ctx.translate(7.632977492722385, 11.15704308607177);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 0.565, 1.5831461853652529, 3.150518588170521, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-7.632977492722385, -11.15704308607177);
  ctx.bezierCurveTo(
    7.068,
    10.837,
    7.318,
    10.581999999999999,
    7.6259999999999994,
    10.581999999999999
  );
  ctx.bezierCurveTo(
    7.933999999999999,
    10.581999999999999,
    8.184,
    10.837,
    8.196,
    NaN
  );
  ctx.moveTo(13.518, 9.003);
  ctx.bezierCurveTo(13.518, 9.318, 13.268, 9.573, 12.96, 9.573);
  ctx.translate(12.966977492722386, 9.00804308607177);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 0.565, 1.5831461853652529, 3.150518588170521, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-12.966977492722386, -9.00804308607177);
  ctx.bezierCurveTo(
    12.402000000000001,
    8.687,
    12.652000000000001,
    8.432,
    12.96,
    8.432
  );
  ctx.bezierCurveTo(
    13.268,
    8.432,
    13.518,
    8.687000000000001,
    13.530000000000001,
    NaN
  );
  ctx.moveTo(15.216, 6.006);
  ctx.bezierCurveTo(15.216, 6.322, 14.966, 6.577, 14.657, 6.577);
  ctx.translate(14.663977492722385, 6.01204308607177);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 0.565, 1.5831461853652529, 3.150518588170521, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-14.663977492722385, -6.01204308607177);
  ctx.bezierCurveTo(14.099, 5.691, 14.349, 5.436, 14.657, 5.436);
  ctx.bezierCurveTo(14.966, 5.436, 15.216, 5.691, 15.227, NaN);
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#e3482c';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(8.082, 16.49);
  ctx.lineTo(6.452000000000001, 13.597999999999999);
  ctx.translate(7.550168029464652, 14.811999991376327);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 1.637, -2.306139647203975, -1.5708989715505144, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-7.550168029464652, -14.811999991376327);
  ctx.bezierCurveTo(
    8.469000000000001,
    13.174999999999999,
    9.214,
    13.937,
    9.214,
    14.876
  );
  ctx.translate(7.5140335779773295, 14.886684755282294);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 1.7, -0.006285191547278363, 1.2301483605310315, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-7.5140335779773295, -14.886684755282294);
  ctx.closePath();
  ctx.moveTo(13.235, 6.938);
  ctx.bezierCurveTo(
    13.235,
    8.008,
    12.386,
    8.876999999999999,
    11.34,
    8.876999999999999
  );
  ctx.bezierCurveTo(
    10.293,
    8.876999999999999,
    9.443999999999999,
    8.008999999999999,
    9.443999999999999,
    6.937999999999999
  );
  ctx.bezierCurveTo(
    9.443999999999999,
    5.8679999999999986,
    10.293,
    4.999999999999999,
    11.34,
    4.999999999999999
  );
  ctx.bezierCurveTo(
    12.386,
    4.999999999999999,
    13.235,
    5.867999999999999,
    13.235,
    6.937999999999999
  );
  ctx.closePath();
  ctx.moveTo(6.73, 9.624);
  ctx.bezierCurveTo(
    7.748,
    9.624,
    8.572000000000001,
    8.781,
    8.572000000000001,
    7.74
  );
  ctx.bezierCurveTo(
    8.572000000000001,
    6.7,
    7.748000000000001,
    5.856,
    6.731000000000001,
    5.856
  );
  ctx.bezierCurveTo(
    5.713000000000001,
    5.856,
    4.889000000000001,
    6.7,
    4.889000000000001,
    7.74
  );
  ctx.bezierCurveTo(
    4.889000000000001,
    8.780000000000001,
    5.713000000000001,
    9.624,
    6.731000000000002,
    9.624
  );
  ctx.closePath();
  ctx.moveTo(12.164, 11.798);
  ctx.bezierCurveTo(12.164, 12.738, 11.419, 13.5, 10.5, 13.5);
  ctx.bezierCurveTo(9.581, 13.5, 8.836, 12.738, 8.836, 11.798);
  ctx.bezierCurveTo(8.836, 10.858, 9.581, 10.097, 10.5, 10.097);
  ctx.bezierCurveTo(11.419, 10.097, 12.164, 10.857999999999999, 12.164, 11.798);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
